import approval from '@/api/hr/approval-request'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
	approve_status: 2,
}

export const getters = {}

export const mutations = {
  ...baseMutations,
	SET_APPROVE_STATUS(state, value){
		state.approve_status = value
	}
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
      },
      attrubutes
    )
    return approval.getApprovalList({ params })
  },
	historyFetch(context, attrubutes = {}){
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
					app_type_id: 1,
					approve_status: context.state.approve_status,
          search: context.state.search
        }
      },
      attrubutes
    )
    return approval.getApprovalList({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
	},
  store(context, data) {
    return approval.store(data)
  }
}
